import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';
import { CALL_API } from 'redux-api-middleware';
import { ROUTE } from '../../middleware/route';
import { MEDICINE_API, PHARMACY_API } from '../../../../config/endpoints';
import paths from '../../../routes/paths';
// eslint-disable-next-line import/no-cycle
import { ADD_REORDER_ITEM, FETCH_CC_STORES_REQUEST } from '../orders';
import { UPDATE_USER_DELIVERY_ADDRESS_RECEIVE } from '../user';

// ACTIONS
export const SET_ORDER_NOTES = 'NEW_ORDER/SET_ORDER_NOTES';
export const ADD_ORDER_ITEM = 'NEW_ORDER/ADD_ORDER_ITEM';
export const SELECTED_MEDICINE_ITEM = 'NEW_ORDER/SELECTED_MEDICINE_ITEM';
export const SELECTED_MEDICINE_FORM = 'NEW_ORDER/SELECTED_MEDICINE_FORM';
export const SELECT_MEDICINE_FORM_INDEX =
  'NEW_ORDER/SELECT_MEDICINE_FORM_INDEX';
export const SET_ORDER_DUE_DATE = 'NEW_ORDER/SET_ORDER_DUE_DATE';
export const REMOVE_ORDER_ITEM = 'NEW_ORDER/REMOVE_ORDER_ITEM';
export const CREATE_ORDER_REQUEST = 'NEW_ORDER/CREATE_ORDER_REQUEST';
export const CREATE_ORDER_RECEIVE = 'NEW_ORDER/CREATE_ORDER_RECEIVE';
export const CREATE_ORDER_FAILURE = 'NEW_ORDER/CREATE_ORDER_FAILURE';
export const CLEAR_CREATE_ERROR = 'NEW_ORDER/CLEAR_CREATE_ERROR';
export const SET_ERROR_ADDING_ITEM = 'NEW_ORDER/SET_ERROR_ADDING_ITEM';
export const CLEAR_ERROR_ADDING_ITEM = 'NEW_ORDER/CLEAR_ERROR_ADDING_ITEM';
export const CLEAR_NEW_ORDER_FLOW = 'NEW_ORDER/CLEAR_NEW_ORDER_FLOW';
export const FETCH_AMPS_REQUEST = 'NEW_ORDER/FETCH_AMPS_REQUEST';
export const FETCH_AMPS_RECEIVE = 'NEW_ORDER/FETCH_AMPS_RECEIVE';
export const FETCH_AMPS_FAILURE = 'NEW_ORDER/FETCH_AMPS_FAILURE';
export const FETCH_REORDER_REQUEST = 'NEW_ORDER/FETCH_REORDER_REQUEST';
export const FETCH_REORDER_RECEIVE = 'NEW_ORDER/FETCH_REORDER_RECEIVE';
export const FETCH_REORDER_FAILURE = 'NEW_ORDER/FETCH_REORDER_FAILURE';
export const SELECT_CC_PHARMACY = 'SELECT_CC_PHARMACY';
export const SELECTED_CC_PHARMACY = 'SELECTED_CC_PHARMACY';
export const CLEAR_SELECTED_CC_PHARMACY = 'CLEAR_SELECTED_CC_PHARMACY';
export const CONFIRMED_CC_PHARMACY = 'CONFIRMED_CC_PHARMACY';

// ACTION CREATORS
export const setOrderNotes = (notes) => ({
  type: SET_ORDER_NOTES,
  notes,
});

export const setOrderDueDate = (dueDate) => ({
  type: SET_ORDER_DUE_DATE,
  dueDate,
});

export const addOrderItem = (item) => {
  if (!item) return { type: SET_ERROR_ADDING_ITEM };
  return {
    type: ADD_ORDER_ITEM,
    item,
    [ROUTE]: paths.createOrder.basket,
  };
};

export const selectedMedicine = (item) => {
  if (!item) return { type: SET_ERROR_ADDING_ITEM };
  return {
    type: SELECTED_MEDICINE_ITEM,
    item,
    [ROUTE]: paths.createOrder.selectMedicineForm,
  };
};

export const selectedMedicineForm = (item) => {
  if (!item) return { type: SET_ERROR_ADDING_ITEM };
  return {
    type: SELECTED_MEDICINE_FORM,
    item,
    [ROUTE]: paths.createOrder.selectMedicineStrength,
  };
};

export const selectMedicineFormIndex = (index) => ({
  type: SELECT_MEDICINE_FORM_INDEX,
  index,
});

export const removeOrderItem = (index, isLastItem) => ({
  type: REMOVE_ORDER_ITEM,
  index,
  [ROUTE]: isLastItem ? paths.createOrder.addMedicine : null,
});

export const fetchAMPs = (AMPs = [], apiEndpoint = MEDICINE_API) => ({
  [CALL_API]: {
    endpoint: `${apiEndpoint}/amps?ids=${AMPs.join(',')}`,
    method: 'GET',
    types: [FETCH_AMPS_REQUEST, FETCH_AMPS_RECEIVE, FETCH_AMPS_FAILURE],
    options: { addAuth: true },
  },
});

export const fetchPreviouslyOrderedItems = (apiEndpoint = PHARMACY_API) => ({
  [CALL_API]: {
    endpoint: `${apiEndpoint}/public/me/items`,
    method: 'GET',
    types: [
      FETCH_REORDER_REQUEST,
      FETCH_REORDER_RECEIVE,
      FETCH_REORDER_FAILURE,
    ],
    options: { addAuth: true },
  },
});

export const createOrder = (
  medicines,
  notes,
  dueDate,
  ccPharmacySelected,
  deliveryAddress,
  apiEndpoint = PHARMACY_API,
  createDefaultDueDate = () => new Date()
) => ({
  [CALL_API]: {
    endpoint: `${apiEndpoint}/public/orders`,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      medicines: medicines.map((m) => ({
        vmpId: m.vmpId,
        ampId: m.packages ? m.packages[0].ampId : m.ampId ?? '',
      })),
      notes,
      due_date: dueDate
        ? new Date(dueDate).toISOString()
        : createDefaultDueDate().toISOString(),
      deliveryPreferences: ccPharmacySelected
        ? {
            method: 'cc',
            branchId: ccPharmacySelected.id,
            deliveryAddress,
          }
        : undefined,
    }),
    types: [
      CREATE_ORDER_REQUEST,
      {
        type: CREATE_ORDER_RECEIVE,
        meta: { [ROUTE]: paths.createOrder.complete },
      },
      CREATE_ORDER_FAILURE,
    ],
    options: { addAuth: true },
  },
});

export const clearCreateError = () => ({
  type: CLEAR_CREATE_ERROR,
});

export const clearAddItemError = () => ({
  type: CLEAR_ERROR_ADDING_ITEM,
});

export const clearNewOrderFlow = (fromHomeReorder) => ({
  type: CLEAR_NEW_ORDER_FLOW,
  fromHomeReorder,
});

export const selectCCPharmacy = (pharmacy) => ({
  type: SELECT_CC_PHARMACY,
  pharmacy,
});

export const selectedCCPharmacy = (pharmacy) => ({
  type: SELECTED_CC_PHARMACY,
  pharmacy,
  [ROUTE]: paths.createOrder.ccConfirmPharmacy,
});

export const confirmedCCPharmacy = () => ({
  type: CONFIRMED_CC_PHARMACY,
  [ROUTE]: paths.createOrder.summary,
});

export const clearSelectedCCPharmacy = () => ({
  type: CLEAR_SELECTED_CC_PHARMACY,
  [ROUTE]: paths.createOrder.summary,
});

// SELECTORS
export const getNotes = (state) => state.notes;
export const getItems = (state) => state.items;
export const getSelectedMedicine = (state) => state.selectedMedicineItem;
export const getSelectedFormIndex = (state) => state.selectedFormIndex;
export const getSelectedMedicineFormItem = (state) =>
  state.selectedMedicineFormItem;
export const getDueDate = (state) => state.dueDate;
export const getCreatingOrder = (state) => state.creatingOrder;
export const getCreateError = (state) => state.createError;
export const getHasErrorAddingItem = (state) => state.errorAddingItem;
export const getCCPharmacySelected = (state) => state.ccPharmacySelected;

// REDUCERS
export const notes = handleActions(
  {
    [SET_ORDER_NOTES]: (_, action) => action.notes,
    [CREATE_ORDER_RECEIVE]: () => '',
    [CLEAR_NEW_ORDER_FLOW]: () => '',
  },
  ''
);

export const dueDate = handleActions(
  {
    [SET_ORDER_DUE_DATE]: (_, action) => action.dueDate,
    [CREATE_ORDER_RECEIVE]: () => null,
    [CLEAR_NEW_ORDER_FLOW]: () => null,
  },
  ''
);

export const items = handleActions(
  {
    [ADD_ORDER_ITEM]: (state, action) => [...state, action.item],
    [ADD_REORDER_ITEM]: (state, action) => [...state, ...action.item],
    [REMOVE_ORDER_ITEM]: (state, action) =>
      state.filter((m, i) => i !== action.index),
    [CREATE_ORDER_RECEIVE]: () => [],
    [CLEAR_NEW_ORDER_FLOW]: (state, action) => {
      if (action.fromHomeReorder) {
        return [...state];
      }
      return [];
    },
  },
  []
);

export const creatingOrder = handleActions(
  {
    [CREATE_ORDER_REQUEST]: () => true,
    [CREATE_ORDER_RECEIVE]: () => false,
    [CREATE_ORDER_FAILURE]: () => false,
    [CLEAR_NEW_ORDER_FLOW]: () => false,
  },
  false
);

export const createError = handleActions(
  {
    [CREATE_ORDER_REQUEST]: () => null,
    [CREATE_ORDER_RECEIVE]: () => null,
    [CREATE_ORDER_FAILURE]: () => 'Something went wrong. Please try again.',
    [CLEAR_CREATE_ERROR]: () => null,
    [REMOVE_ORDER_ITEM]: () => null,
    [SET_ORDER_NOTES]: () => null,
    [SET_ORDER_DUE_DATE]: () => null,
    [ADD_ORDER_ITEM]: () => null,
    [CLEAR_NEW_ORDER_FLOW]: () => null,
  },
  null
);

export const errorAddingItem = handleActions(
  {
    [ADD_ORDER_ITEM]: () => false,
    [SELECTED_MEDICINE_ITEM]: () => false,
    [SELECTED_MEDICINE_FORM]: () => false,
    [CLEAR_ERROR_ADDING_ITEM]: () => false,
    [SET_ERROR_ADDING_ITEM]: () => true,
    [CLEAR_NEW_ORDER_FLOW]: () => false,
  },
  false
);

export const selectedMedicineItem = handleActions(
  {
    [SELECTED_MEDICINE_ITEM]: (state, action) => action.item,
  },
  null
);

export const selectedMedicineFormItem = handleActions(
  {
    [SELECTED_MEDICINE_FORM]: (state, action) => action.item,
    [FETCH_AMPS_FAILURE]: () => [],
  },
  []
);

export const selectedFormIndex = handleActions(
  {
    [SELECT_MEDICINE_FORM_INDEX]: (state, action) => action.index,
  },
  null
);

export const ccPharmacySelected = handleActions(
  {
    [SELECT_CC_PHARMACY]: (state, action) => action.pharmacy,
    [SELECTED_CC_PHARMACY]: (state, action) => action.pharmacy,
    [UPDATE_USER_DELIVERY_ADDRESS_RECEIVE]: () => null,
    [FETCH_CC_STORES_REQUEST]: () => null,
    [CLEAR_SELECTED_CC_PHARMACY]: () => null,
    [CLEAR_NEW_ORDER_FLOW]: () => null,
  },
  null
);

export default combineReducers({
  notes,
  dueDate,
  items,
  selectedMedicineItem,
  selectedMedicineFormItem,
  selectedFormIndex,
  creatingOrder,
  createError,
  errorAddingItem,
  ccPharmacySelected,
});
